/* PromoteFooter — the single primary CTA at the bottom of the
 * Rule Builder. Per Spec 07 §"Three surfaces, one verb": the verb
 * everywhere is "promote".
 *
 * Disabled until:
 *   • validator.ok           — no type / unknown-path errors, and
 *   • testedAtLeastOnce      — designer has clicked Test once.
 *
 * Cancel returns to wherever the user came from (history-back).
 */

import { useNavigate } from "react-router-dom";
import { ChevronRight, X } from "lucide-react";
import { cls } from "../../../lib/cls";

interface PromoteFooterProps {
  projectName: string;
  canPromote: boolean;
  reason: string;
  onPromote: () => void;
}

export function PromoteFooter({ projectName, canPromote, reason, onPromote }: PromoteFooterProps): JSX.Element {
  const nav = useNavigate();
  return (
    <div className="sticky bottom-0 left-0 right-0 -mx-4 sm:-mx-8 px-4 sm:px-8 py-3 bg-cream/85 backdrop-blur border-t border-border z-20">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={() => nav(-1)}
          className="btn btn-outline !py-2 !px-3 !text-[13px]"
          title="Discard and go back"
        >
          <X className="w-3.5 h-3.5" /><span>Cancel</span>
        </button>
        <div className="flex items-center gap-3">
          <span className="text-[12px] text-ink-500 max-w-[420px] text-right">{reason}</span>
          <button
            type="button"
            onClick={onPromote}
            disabled={!canPromote}
            className={cls(
              "btn !py-2 !px-4 !text-[13px]",
              canPromote ? "btn-foyr" : "btn-outline opacity-60 cursor-not-allowed",
            )}
            title={canPromote ? `Promote to ${projectName}` : reason}
          >
            <span>Promote to {projectName}</span>
            <ChevronRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
